<template>
  <div class="t-review">
    <div class="t-review__belonging" v-if="!course.belonging && data.belonging">
      <svg width="22" height="25" viewBox="0 0 22 25" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path fill-rule="evenodd" clip-rule="evenodd"
              d="M6.00001 7C6.00001 4.23858 8.23859 2 11 2C13.7614 2 16 4.23858 16 7C16 9.76142 13.7614 12 11 12C8.23859 12 6.00001 9.76142 6.00001 7ZM15.2337 12.575C16.9148 11.2965 18 9.27497 18 7C18 3.13401 14.866 0 11 0C7.13402 0 4.00001 3.13401 4.00001 7C4.00001 9.27497 5.08526 11.2965 6.76629 12.575C5.5579 12.8913 4.36923 13.3444 3.45384 13.9413C1.68818 15.0925 0.817112 16.6786 0.398127 18.4468C-0.000292949 20.1283 -0.000141672 22.0291 5.67025e-06 23.8923L1.21076e-05 24C1.21076e-05 24.5523 0.447727 25 1.00001 25C1.5523 25 2.00001 24.5523 2.00001 24C2.00001 22.036 2.00289 20.3486 2.34424 18.908C2.6727 17.5217 3.30164 16.4281 4.54619 15.6166C5.27671 15.1403 6.35199 14.7297 7.55204 14.4395C8.74192 14.1518 9.98136 14 11 14C12.0187 14 13.2581 14.1518 14.448 14.4395C15.648 14.7297 16.7233 15.1403 17.4538 15.6166C18.6984 16.4281 19.3273 17.5217 19.6558 18.908C19.9971 20.3486 20 22.036 20 24C20 24.5523 20.4477 25 21 25C21.5523 25 22 24.5523 22 24L22 23.8923C22.0002 22.0291 22.0003 20.1283 21.6019 18.4468C21.1829 16.6786 20.3118 15.0925 18.5462 13.9413C17.6308 13.3444 16.4421 12.8913 15.2337 12.575Z"
              fill="#B8D7F5"/>
      </svg>
    </div>
    <div class="t-review__title">{{ reviewText.title_1 }}
      <template v-if="data.claim">— {{ reviewText.title_2 }}</template>
      <span v-if="data.hidden">{{ reviewText.title_3 }}</span></div>
    <router-link class="t-review__user" :to="{name: 'user', params: {url: data.userUrl}}">
      <img :src="data.userImg" v-if="data.userImg !== ''">
      <img src="/img/default_img.png" v-else>
      <p>{{ data.userName }}</p>
    </router-link>
    <cmp-rating :rate="data.rate" size="big"></cmp-rating>
    <div class="t-input">
      <input type="radio" :id="'reviews_' + data.id + '_type'" class="t-radio" checked>
      <label :for="'reviews_' + data.id + '_type'">{{ data.type }}</label>
    </div>
    <div class="t-review__text" :class="{_small: data.claim && course.belonging}" v-if="data.text !== ''">
      <span v-html="data.text"></span>
    </div>
    <div class="t-review__buttons">
      <button @click.prevent="Open()" v-if="readMore">{{ reviewText.open }} ...</button>
    </div>
    <div class="t-review__buttons t-review__buttons_absolute"
         v-if="course.belonging && data.claim && data.result === null">
      <button class="t-btn" @click.prevent="Claim(true)"><span>{{ reviewText.claimTrue }}</span></button>
      <button class="t-btn" @click.prevent="Claim(false)"><span>{{ reviewText.claimFalse }}</span></button>
    </div>
    <div class="t-review__result" v-if="course.belonging && data.claim && data.result !== null">{{ data.result }}</div>

    <div class="t-review_dialog" v-if="open">
      <div class="t-dialog__overlay">
        <span @click.prevent="Close()" class="t-dialog__close"></span>
      </div>
      <div class="t-review">
        <div class="t-review__belonging" v-if="data.belonging">
          <svg width="22" height="25" viewBox="0 0 22 25" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path fill-rule="evenodd" clip-rule="evenodd"
                  d="M6.00001 7C6.00001 4.23858 8.23859 2 11 2C13.7614 2 16 4.23858 16 7C16 9.76142 13.7614 12 11 12C8.23859 12 6.00001 9.76142 6.00001 7ZM15.2337 12.575C16.9148 11.2965 18 9.27497 18 7C18 3.13401 14.866 0 11 0C7.13402 0 4.00001 3.13401 4.00001 7C4.00001 9.27497 5.08526 11.2965 6.76629 12.575C5.5579 12.8913 4.36923 13.3444 3.45384 13.9413C1.68818 15.0925 0.817112 16.6786 0.398127 18.4468C-0.000292949 20.1283 -0.000141672 22.0291 5.67025e-06 23.8923L1.21076e-05 24C1.21076e-05 24.5523 0.447727 25 1.00001 25C1.5523 25 2.00001 24.5523 2.00001 24C2.00001 22.036 2.00289 20.3486 2.34424 18.908C2.6727 17.5217 3.30164 16.4281 4.54619 15.6166C5.27671 15.1403 6.35199 14.7297 7.55204 14.4395C8.74192 14.1518 9.98136 14 11 14C12.0187 14 13.2581 14.1518 14.448 14.4395C15.648 14.7297 16.7233 15.1403 17.4538 15.6166C18.6984 16.4281 19.3273 17.5217 19.6558 18.908C19.9971 20.3486 20 22.036 20 24C20 24.5523 20.4477 25 21 25C21.5523 25 22 24.5523 22 24L22 23.8923C22.0002 22.0291 22.0003 20.1283 21.6019 18.4468C21.1829 16.6786 20.3118 15.0925 18.5462 13.9413C17.6308 13.3444 16.4421 12.8913 15.2337 12.575Z"
                  fill="#B8D7F5"/>
          </svg>
        </div>
        <div class="t-review__title">{{ reviewText.title_1 }}
          <template v-if="data.claim">— {{ reviewText.title_2 }}</template>
          <span v-if="data.hidden">{{ reviewText.title_3 }}</span></div>
        <ul class="t-review__rate">
          <li>
            <svg width="18" height="36" viewBox="0 0 18 36" fill="none" xmlns="http://www.w3.org/2000/svg">
              <mask id="mask0" mask-type="alpha" maskUnits="userSpaceOnUse" x="0" y="0" width="18" height="36">
                <rect width="18" height="36" fill="#C4C4C4"/>
              </mask>
              <g mask="url(#mask0)">
                <path
                  d="M16.1631 4.26548C16.8573 2.65356 19.1427 2.65356 19.8369 4.26549L22.9379 11.4663C23.2275 12.1387 23.8612 12.5991 24.5901 12.6667L32.3968 13.3908C34.1443 13.5528 34.8506 15.7265 33.5321 16.8848L27.6419 22.0592C27.0919 22.5423 26.8499 23.2873 27.0108 24.0015L28.7346 31.6498C29.1205 33.3619 27.2715 34.7053 25.7624 33.8092L19.0211 29.8063C18.3917 29.4326 17.6083 29.4326 16.9789 29.8063L10.2376 33.8092C8.72851 34.7053 6.87952 33.3619 7.26539 31.6498L8.98917 24.0015C9.15013 23.2873 8.90806 22.5423 8.35809 22.0592L2.46795 16.8848C1.14943 15.7265 1.85568 13.5528 3.60322 13.3908L11.4099 12.6667C12.1388 12.5991 12.7725 12.1387 13.0621 11.4663L16.1631 4.26548Z"
                  :fill="data.rate >=1 ? '#59DCED' : '#84C1F6'" :fill-opacity="data.rate >=1 ? 1 : 0.4"/>
              </g>
            </svg>
            <svg width="18" height="36" viewBox="0 0 18 36" fill="none" xmlns="http://www.w3.org/2000/svg">
              <mask id="mask0" mask-type="alpha" maskUnits="userSpaceOnUse" x="0" y="0" width="18" height="36">
                <rect width="18" height="36" fill="#C4C4C4"/>
              </mask>
              <g mask="url(#mask0)">
                <path
                  d="M-1.83691 4.26548C-1.14274 2.65356 1.14274 2.65356 1.83691 4.26549L4.93791 11.4663C5.22745 12.1387 5.86119 12.5991 6.59011 12.6667L14.3968 13.3908C16.1443 13.5528 16.8506 15.7265 15.5321 16.8848L9.64191 22.0592C9.09194 22.5423 8.84987 23.2873 9.01083 24.0015L10.7346 31.6498C11.1205 33.3619 9.27149 34.7053 7.76243 33.8092L1.02112 29.8063C0.391674 29.4326 -0.391674 29.4326 -1.02112 29.8063L-7.76243 33.8092C-9.27149 34.7053 -11.1205 33.3619 -10.7346 31.6498L-9.01083 24.0015C-8.84987 23.2873 -9.09194 22.5423 -9.64191 22.0592L-15.5321 16.8848C-16.8506 15.7265 -16.1443 13.5528 -14.3968 13.3908L-6.59012 12.6667C-5.8612 12.5991 -5.22745 12.1387 -4.93791 11.4663L-1.83691 4.26548Z"
                  :fill="data.rate >=2 ? '#59DCED' : '#84C1F6'" :fill-opacity="data.rate >=2 ? 1 : 0.4"/>
              </g>
            </svg>
          </li>
          <li>
            <svg width="18" height="36" viewBox="0 0 18 36" fill="none" xmlns="http://www.w3.org/2000/svg">
              <mask id="mask0" mask-type="alpha" maskUnits="userSpaceOnUse" x="0" y="0" width="18" height="36">
                <rect width="18" height="36" fill="#C4C4C4"/>
              </mask>
              <g mask="url(#mask0)">
                <path
                  d="M16.1631 4.26548C16.8573 2.65356 19.1427 2.65356 19.8369 4.26549L22.9379 11.4663C23.2275 12.1387 23.8612 12.5991 24.5901 12.6667L32.3968 13.3908C34.1443 13.5528 34.8506 15.7265 33.5321 16.8848L27.6419 22.0592C27.0919 22.5423 26.8499 23.2873 27.0108 24.0015L28.7346 31.6498C29.1205 33.3619 27.2715 34.7053 25.7624 33.8092L19.0211 29.8063C18.3917 29.4326 17.6083 29.4326 16.9789 29.8063L10.2376 33.8092C8.72851 34.7053 6.87952 33.3619 7.26539 31.6498L8.98917 24.0015C9.15013 23.2873 8.90806 22.5423 8.35809 22.0592L2.46795 16.8848C1.14943 15.7265 1.85568 13.5528 3.60322 13.3908L11.4099 12.6667C12.1388 12.5991 12.7725 12.1387 13.0621 11.4663L16.1631 4.26548Z"
                  :fill="data.rate >=3 ? '#59DCED' : '#84C1F6'" :fill-opacity="data.rate >=3 ? 1 : 0.4"/>
              </g>
            </svg>
            <svg width="18" height="36" viewBox="0 0 18 36" fill="none" xmlns="http://www.w3.org/2000/svg">
              <mask id="mask0" mask-type="alpha" maskUnits="userSpaceOnUse" x="0" y="0" width="18" height="36">
                <rect width="18" height="36" fill="#C4C4C4"/>
              </mask>
              <g mask="url(#mask0)">
                <path
                  d="M-1.83691 4.26548C-1.14274 2.65356 1.14274 2.65356 1.83691 4.26549L4.93791 11.4663C5.22745 12.1387 5.86119 12.5991 6.59011 12.6667L14.3968 13.3908C16.1443 13.5528 16.8506 15.7265 15.5321 16.8848L9.64191 22.0592C9.09194 22.5423 8.84987 23.2873 9.01083 24.0015L10.7346 31.6498C11.1205 33.3619 9.27149 34.7053 7.76243 33.8092L1.02112 29.8063C0.391674 29.4326 -0.391674 29.4326 -1.02112 29.8063L-7.76243 33.8092C-9.27149 34.7053 -11.1205 33.3619 -10.7346 31.6498L-9.01083 24.0015C-8.84987 23.2873 -9.09194 22.5423 -9.64191 22.0592L-15.5321 16.8848C-16.8506 15.7265 -16.1443 13.5528 -14.3968 13.3908L-6.59012 12.6667C-5.8612 12.5991 -5.22745 12.1387 -4.93791 11.4663L-1.83691 4.26548Z"
                  :fill="data.rate >=4 ? '#59DCED' : '#84C1F6'" fill-opacity="0.4"
                  :fill-opacity="data.rate >=4 ? 1 : 0.4"/>
              </g>
            </svg>
          </li>
          <li>
            <svg width="18" height="36" viewBox="0 0 18 36" fill="none" xmlns="http://www.w3.org/2000/svg">
              <mask id="mask0" mask-type="alpha" maskUnits="userSpaceOnUse" x="0" y="0" width="18" height="36">
                <rect width="18" height="36" fill="#C4C4C4"/>
              </mask>
              <g mask="url(#mask0)">
                <path
                  d="M16.1631 4.26548C16.8573 2.65356 19.1427 2.65356 19.8369 4.26549L22.9379 11.4663C23.2275 12.1387 23.8612 12.5991 24.5901 12.6667L32.3968 13.3908C34.1443 13.5528 34.8506 15.7265 33.5321 16.8848L27.6419 22.0592C27.0919 22.5423 26.8499 23.2873 27.0108 24.0015L28.7346 31.6498C29.1205 33.3619 27.2715 34.7053 25.7624 33.8092L19.0211 29.8063C18.3917 29.4326 17.6083 29.4326 16.9789 29.8063L10.2376 33.8092C8.72851 34.7053 6.87952 33.3619 7.26539 31.6498L8.98917 24.0015C9.15013 23.2873 8.90806 22.5423 8.35809 22.0592L2.46795 16.8848C1.14943 15.7265 1.85568 13.5528 3.60322 13.3908L11.4099 12.6667C12.1388 12.5991 12.7725 12.1387 13.0621 11.4663L16.1631 4.26548Z"
                  :fill="data.rate >=5 ? '#59DCED' : '#84C1F6'" :fill-opacity="data.rate >=5 ? 1 : 0.4"/>
              </g>
            </svg>
            <svg width="18" height="36" viewBox="0 0 18 36" fill="none" xmlns="http://www.w3.org/2000/svg">
              <mask id="mask0" mask-type="alpha" maskUnits="userSpaceOnUse" x="0" y="0" width="18" height="36">
                <rect width="18" height="36" fill="#C4C4C4"/>
              </mask>
              <g mask="url(#mask0)">
                <path
                  d="M-1.83691 4.26548C-1.14274 2.65356 1.14274 2.65356 1.83691 4.26549L4.93791 11.4663C5.22745 12.1387 5.86119 12.5991 6.59011 12.6667L14.3968 13.3908C16.1443 13.5528 16.8506 15.7265 15.5321 16.8848L9.64191 22.0592C9.09194 22.5423 8.84987 23.2873 9.01083 24.0015L10.7346 31.6498C11.1205 33.3619 9.27149 34.7053 7.76243 33.8092L1.02112 29.8063C0.391674 29.4326 -0.391674 29.4326 -1.02112 29.8063L-7.76243 33.8092C-9.27149 34.7053 -11.1205 33.3619 -10.7346 31.6498L-9.01083 24.0015C-8.84987 23.2873 -9.09194 22.5423 -9.64191 22.0592L-15.5321 16.8848C-16.8506 15.7265 -16.1443 13.5528 -14.3968 13.3908L-6.59012 12.6667C-5.8612 12.5991 -5.22745 12.1387 -4.93791 11.4663L-1.83691 4.26548Z"
                  :fill="data.rate >=6 ? '#59DCED' : '#84C1F6'" :fill-opacity="data.rate >=6 ? 1 : 0.4"/>
              </g>
            </svg>
          </li>
          <li>
            <svg width="18" height="36" viewBox="0 0 18 36" fill="none" xmlns="http://www.w3.org/2000/svg">
              <mask id="mask0" mask-type="alpha" maskUnits="userSpaceOnUse" x="0" y="0" width="18" height="36">
                <rect width="18" height="36" fill="#C4C4C4"/>
              </mask>
              <g mask="url(#mask0)">
                <path
                  d="M16.1631 4.26548C16.8573 2.65356 19.1427 2.65356 19.8369 4.26549L22.9379 11.4663C23.2275 12.1387 23.8612 12.5991 24.5901 12.6667L32.3968 13.3908C34.1443 13.5528 34.8506 15.7265 33.5321 16.8848L27.6419 22.0592C27.0919 22.5423 26.8499 23.2873 27.0108 24.0015L28.7346 31.6498C29.1205 33.3619 27.2715 34.7053 25.7624 33.8092L19.0211 29.8063C18.3917 29.4326 17.6083 29.4326 16.9789 29.8063L10.2376 33.8092C8.72851 34.7053 6.87952 33.3619 7.26539 31.6498L8.98917 24.0015C9.15013 23.2873 8.90806 22.5423 8.35809 22.0592L2.46795 16.8848C1.14943 15.7265 1.85568 13.5528 3.60322 13.3908L11.4099 12.6667C12.1388 12.5991 12.7725 12.1387 13.0621 11.4663L16.1631 4.26548Z"
                  :fill="data.rate >=7 ? '#59DCED' : '#84C1F6'" :fill-opacity="data.rate >=7 ? 1 : 0.4"/>
              </g>
            </svg>
            <svg width="18" height="36" viewBox="0 0 18 36" fill="none" xmlns="http://www.w3.org/2000/svg">
              <mask id="mask0" mask-type="alpha" maskUnits="userSpaceOnUse" x="0" y="0" width="18" height="36">
                <rect width="18" height="36" fill="#C4C4C4"/>
              </mask>
              <g mask="url(#mask0)">
                <path
                  d="M-1.83691 4.26548C-1.14274 2.65356 1.14274 2.65356 1.83691 4.26549L4.93791 11.4663C5.22745 12.1387 5.86119 12.5991 6.59011 12.6667L14.3968 13.3908C16.1443 13.5528 16.8506 15.7265 15.5321 16.8848L9.64191 22.0592C9.09194 22.5423 8.84987 23.2873 9.01083 24.0015L10.7346 31.6498C11.1205 33.3619 9.27149 34.7053 7.76243 33.8092L1.02112 29.8063C0.391674 29.4326 -0.391674 29.4326 -1.02112 29.8063L-7.76243 33.8092C-9.27149 34.7053 -11.1205 33.3619 -10.7346 31.6498L-9.01083 24.0015C-8.84987 23.2873 -9.09194 22.5423 -9.64191 22.0592L-15.5321 16.8848C-16.8506 15.7265 -16.1443 13.5528 -14.3968 13.3908L-6.59012 12.6667C-5.8612 12.5991 -5.22745 12.1387 -4.93791 11.4663L-1.83691 4.26548Z"
                  :fill="data.rate >=8 ? '#59DCED' : '#84C1F6'" :fill-opacity="data.rate >=8 ? 1 : 0.4"/>
              </g>
            </svg>
          </li>
          <li>
            <svg width="18" height="36" viewBox="0 0 18 36" fill="none" xmlns="http://www.w3.org/2000/svg">
              <mask id="mask0" mask-type="alpha" maskUnits="userSpaceOnUse" x="0" y="0" width="18" height="36">
                <rect width="18" height="36" fill="#C4C4C4"/>
              </mask>
              <g mask="url(#mask0)">
                <path
                  d="M16.1631 4.26548C16.8573 2.65356 19.1427 2.65356 19.8369 4.26549L22.9379 11.4663C23.2275 12.1387 23.8612 12.5991 24.5901 12.6667L32.3968 13.3908C34.1443 13.5528 34.8506 15.7265 33.5321 16.8848L27.6419 22.0592C27.0919 22.5423 26.8499 23.2873 27.0108 24.0015L28.7346 31.6498C29.1205 33.3619 27.2715 34.7053 25.7624 33.8092L19.0211 29.8063C18.3917 29.4326 17.6083 29.4326 16.9789 29.8063L10.2376 33.8092C8.72851 34.7053 6.87952 33.3619 7.26539 31.6498L8.98917 24.0015C9.15013 23.2873 8.90806 22.5423 8.35809 22.0592L2.46795 16.8848C1.14943 15.7265 1.85568 13.5528 3.60322 13.3908L11.4099 12.6667C12.1388 12.5991 12.7725 12.1387 13.0621 11.4663L16.1631 4.26548Z"
                  :fill="data.rate >=9 ? '#59DCED' : '#84C1F6'" :fill-opacity="data.rate >=9 ? 1 : 0.4"/>
              </g>
            </svg>
            <svg width="18" height="36" viewBox="0 0 18 36" fill="none" xmlns="http://www.w3.org/2000/svg">
              <mask id="mask0" mask-type="alpha" maskUnits="userSpaceOnUse" x="0" y="0" width="18" height="36">
                <rect width="18" height="36" fill="#C4C4C4"/>
              </mask>
              <g mask="url(#mask0)">
                <path
                  d="M-1.83691 4.26548C-1.14274 2.65356 1.14274 2.65356 1.83691 4.26549L4.93791 11.4663C5.22745 12.1387 5.86119 12.5991 6.59011 12.6667L14.3968 13.3908C16.1443 13.5528 16.8506 15.7265 15.5321 16.8848L9.64191 22.0592C9.09194 22.5423 8.84987 23.2873 9.01083 24.0015L10.7346 31.6498C11.1205 33.3619 9.27149 34.7053 7.76243 33.8092L1.02112 29.8063C0.391674 29.4326 -0.391674 29.4326 -1.02112 29.8063L-7.76243 33.8092C-9.27149 34.7053 -11.1205 33.3619 -10.7346 31.6498L-9.01083 24.0015C-8.84987 23.2873 -9.09194 22.5423 -9.64191 22.0592L-15.5321 16.8848C-16.8506 15.7265 -16.1443 13.5528 -14.3968 13.3908L-6.59012 12.6667C-5.8612 12.5991 -5.22745 12.1387 -4.93791 11.4663L-1.83691 4.26548Z"
                  :fill="data.rate >=10 ? '#59DCED' : '#84C1F6'" :fill-opacity="data.rate >=10 ? 1 : 0.4"/>
              </g>
            </svg>
          </li>
        </ul>
        <div class="t-input">
          <input type="radio" :id="'reviews_' + data.id + '_type'" class="t-radio" checked>
          <label :for="'reviews_' + data.id + '_type'">{{ data.type }}</label>
        </div>
        <div class="t-review__text">
          <v-bar wrapper="t-review__scroll" v-if="!mobileState">
            <span v-html="data.text"></span>
          </v-bar>
          <span v-html="data.text" v-else></span>
        </div>
        <div class="t-review__buttons">
          <button @click.prevent="Close()">{{ reviewText.close }}<span></span></button>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
  import VBar from 'v-bar'
  import {mapActions, mapGetters} from 'vuex'

  import Rating from './Rating.vue';

  export default {
    components: {
      'cmp-rating': Rating,
      VBar
    },
    props: ['data'],
    data() {
      return {
        readMore: false,
        open: false
      }
    },
    computed: {
      ...mapGetters(['mobileState']),
      ...mapGetters('coursesList', ['course']),
      ...mapGetters('staticText', ['reviewText'])
    },
    methods: {
      ...mapActions('modal', ['modalDialogClose']),
      ...mapActions('msg', ['showMsg']),
      ...mapActions('coursesList', ['LoadReviews']),
      Open() {
        this.open = true;
      },
      Close() {
        this.open = false;
        this.modalDialogClose();
      },
      Claim(agree) {
        let fd = new FormData();

        fd.append('agree', agree);

        this.$http.put('agree/' + this.data.id, fd)
          .then(response => {
            if (response.body.success) {
              this.showMsg(this.reviewText.msg);
              this.LoadReviews({id: this.course.id});
            } else {
              this.showMsg('Упс, что-то пошло не так, попробуйте позже');
            }
          }, response => {
            this.showMsg('Упс, что-то пошло не так, попробуйте позже');
          });
      }
    },
    mounted() {
      let box = this.$el.querySelector('.t-review__text');

      if (box) {
        let boxHeight = box.clientHeight,
          textHeight = box.querySelector('span').clientHeight;

        if (textHeight + 32 >= boxHeight) {
          this.readMore = true;
        }
      }
    }
  }
</script>

<style lang="sass">
  @media(min-width: 770px)
    .t-review
      button:not(.t-btn):hover
        color: $blue

  .t-review
    width: 320px
    min-height: 413px
    max-width: 100%
    @extend %substrate
    padding: 24px
    margin: 0 24px 24px 0
    position: relative
    &_dialog
      width: 100%
      position: absolute
      top: 0
      left: 0
      z-index: 101
      .t-review__text
        height: auto
        max-height: calc(100vh - 360px)
        padding: 16px 7px 16px 16px
        span
          height: auto
          padding-right: 7px
      .bar--wrapper
        position: relative
        max-height: calc(100vh - 416px)
        padding-right: 7px
        > span
          margin-bottom: -24px
      .bar--vertical
        margin: 0
        width: 1px
        background: $disabled
      .bar--vertical-internal
        background: $blue
        padding-bottom: 24px
        box-sizing: content-box
      .t-review
        z-index: 2
    &__scroll, .bar--container
      max-height: calc(100vh - 392px)
    &__belonging
      position: absolute
      top: 18px
      right: 15px
      width: 40px
      height: 40px
      display: flex
      align-items: center
      justify-content: center
    &__title
      color: $blue
      font-size: 22px
      line-height: 1.2
      font-weight: bold
      margin-bottom: 24px
      span
        font-weight: normal
        font-size: 14px
        color: $border
    &__user
      display: flex
      align-items: center
      margin: 0 0 24px
      width: 100%
      img
        width: 88px
        height: 88px
        object-fit: cover
        border-radius: 8px
        flex: none
        margin-right: 18px
      p
        flex: 1
        font-weight: bold
        font-size: 22px
        color: $blue
        line-height: 1.2
    &__rate
      display: flex
      align-items: center
      justify-content: flex-start
      margin: 0 0 24px
      padding: 0
      li
        width: 39px
        height: 40px
        margin: 0 8px 0 0
        display: flex
        align-items: center
        justify-content: center
    &__text
      margin-bottom: 16px
      background: #DEF1FA
      border-radius: 8px
      height: 175px
      color: $blue
      padding: 16px
      line-height: 1.3
      &._small
        height: 93px
      span
        overflow: hidden
        display: block
        width: 100%
        max-height: 100%
    &__buttons
      display: flex
      justify-content: flex-end
      width: 100%
      margin-bottom: 65px
      &_absolute
        // position: absolute
        // left: 16px
        // right: 16px
        // bottom: 24px
        width: auto
        justify-content: space-between
        /* position: absolute; */
        /* left: 16px; */
        /* right: 16px; */
        margin: 0 -8px
    &__result
      position: absolute
      left: 0
      right: 0
      bottom: 0
      padding: 14px 14px 24px
      color: #ffffff
      background: $blue
      border-radius: 0 0 16px 16px
      text-align: center
    button:not(.t-btn)
      border: none
      background: transparent
      border-radius: 0
      outline: none
      cursor: pointer
      font-size: 14px
      font-weight: normal
      font-family: 'rubik', Arial, sans-serif
      color: $black
      transition: all .2s
    > *:last-child
      margin-bottom: 0

  @media(max-width: 769px)
    .t-review
      min-height: 413px !important
    .t-review__buttons_absolute
      margin-top: 16px
      flex-direction: column
      position: relative
      bottom: 0
      left: 0
      right: 0
      .t-btn:not(:last-child)
        margin-bottom: 8px
    .t-review__result
      position: relative
      margin: 16px -24px -24px !important
    .t-review_dialog .t-review__text span
      max-height: calc(100vh - 392px)
      overflow-y: scroll

  @media(max-width: 1024px)
    .t-review
      min-height: 495px
</style>



// WEBPACK FOOTER //
// src/vue_components/Reviews.vue